// extracted by mini-css-extract-plugin
export var line = "style-module--line--29f22";
export var lineWrap = "style-module--line-wrap--dc169";
export var marquee = "style-module--marquee--75ca3";
export var numsList = "style-module--nums-list--fb8fe";
export var res = "style-module--res--e81ca";
export var scroll = "style-module--scroll--d22b7";
export var subtitle = "style-module--subtitle--59356";